export default {
  setEmailAutomationLists(state, { data }) {
    state.emailAutomationLists = data.data;
  },
};
